import { render, staticRenderFns } from "./UserGroupSetting.vue?vue&type=template&id=d84c8a76&scoped=true"
import script from "./UserGroupSetting.vue?vue&type=script&lang=js"
export * from "./UserGroupSetting.vue?vue&type=script&lang=js"
import style0 from "./UserGroupSetting.vue?vue&type=style&index=0&id=d84c8a76&prod&lang=scss&scoped=true"
import style1 from "./UserGroupSetting.vue?vue&type=style&index=1&id=d84c8a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84c8a76",
  null
  
)

export default component.exports